type Props = {
	feedbackChildren: React.ReactNode;
	recommendedTagListChildren: React.ReactNode;
};
export const RecommendedTagListSection = ({ feedbackChildren, recommendedTagListChildren }: Props) => {
	return (
		<div className="space-y-1">
			{/* おすすめタグについて */}
			{feedbackChildren}

			<p>おすすめのタグ一覧</p>
			{recommendedTagListChildren}
		</div>
	);
};
